import React, {useEffect, useState, useRef, useCallback} from 'react';
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { MenuItem } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import _ from 'lodash';
import MapView from '../../components/MapView';
import HideablePanel from '../../components/HideablePanel';
import HideablePanelHeader from '../../components/HideablePanel/HideablePanelHeader';
import DriverSearch from '../../components/MapManagement/DriverSearch';
import AccountList from '../../components/MapManagement/AccountList';
import { useDispatch, useSelector } from 'react-redux';
import { showAlertSnackbar } from '../../reducers/uiSlice';
import { assignOrderToDriver, getDistricts, getStaffList } from '../../actions/mmActions';
import ListError from '../../components/Common/ListError';
import { getAccountFilteredDistricts, getUserPreference } from '../../utilities/common';
import { getMapCenterByCityId } from '../../utilities/map';
import { useTranslation } from 'react-i18next';
import { getOrderFilter } from '../../reducers/filterSlice';
import { getLetianStaff, quickTransferOrders } from '../../actions/ddActions';
import LocalDeliveryManagement from '../../components/LocalDeliveryManagement';
import { getLocalDeliveryOrders } from '../../actions/localStorageActions';
import FullscreenLoading from '../../components/Common/FullscreenLoading';

const useStyles = makeStyles((theme)=> ({
    leftPanel: {
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        maxheight: '100%',
        // width: '350px',
        zIndex: theme.zIndex.drawer,
    },
    rightPanel: {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        maxheight: '100%',
        // width: '550px',
        zIndex: theme.zIndex.drawer,
    },
    label: {
        flexDirection: 'column'
    },
    routePlanner: {
        transform: 'translate(0, 40vh)'
    },
    mapInfoWindow: {
        //backgroundColor: theme.palette.background.default
    },
    driverStyle: {
        marginTop: 20,
        padding: '10 5'
    },
    titleStyle: {
        marginBottom: 10
    }
}))

const workTabs = [
    {label: "A", value: 0},
    {label: "B", value: 1},
    {label: "Driver On", value: 2},
    {label: "Driver Off", value: 3}
]

function LocalDelivery() {
    const classes = useStyles();
    const {t} = useTranslation('mapManagement');

    let userPref = getUserPreference();
    let orderFilters = useSelector(getOrderFilter);

    const dispatch = useDispatch();
    const mapManagement = useSelector(state => state.mapManagement);
    const routeManagement = useSelector(state => state.routeManagement);
    const [accountSearchKeyword, setAccountSearchKeyword] = useState("");
    const [openInfoWindow, setOpenInfoWindow] = useState();
    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = useState([]);
    const [allChecked, setAllChecked] = useState(false);
    const [isChecked, setIsChecked] = useState([]);
    const [checkedOrders, setCheckedOrders] = useState([]);
    const [loadingFullscreen, setLoadingFullscreen] = useState(false);

    const delaySearch = useCallback(_.debounce(value=>setAccountSearchKeyword(value), 350), [])
    const rightPanelDisable = rightPanelLock()

    const renderTime = ({ remainingTime }) => {
        if (remainingTime === 0) {
            setLoading(true);
            dispatch(getLocalDeliveryOrders())
            .then((res) => {
                setOrders(res);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            })
        }
        return (
            <div>{remainingTime}</div>
        );
    };

    useEffect(() => {
        if(userPref.userCity == null){
            console.error("[FATAL] City ID Missing!")
            dispatch(showAlertSnackbar({
                title: "[FATAL] City ID Missing!", 
                message: "Please contact administrator to sort out this problem! If it's resolved please login again!",
                duration: 15000
            }))
        }
        if(mapManagement.staff.length <= 0){
            dispatch(getStaffList(userPref.userCity, 1))
        }
        dispatch(getDistricts())
        dispatch(getLetianStaff(userPref.userCity))
        setLoading(true);
        dispatch(getLocalDeliveryOrders())
        .then((res) => {
            setOrders(res);
            setLoading(false);
        })
        .catch(() => {
            setLoading(false);
        })
    }, [])
    useEffect(() => {
        if(orders) {
            if(orders.length > 0) {
                setIsChecked(orders.slice().fill(false));
            }
            clearAllChecked(false);
            setCheckedOrders([]);
        }
    }, [orders])

    return (
        <div style={{width:'100vw', height: '100vh'}}>
            <HideablePanel
                id='leftPanel'
                containerStyle={classes.leftPanel} 
                position='left'
                tabs={[
                    {label: "Orders", value: 0}
                ]}
                usageFor='local_delivery'
                headerComponent={
                    <HideablePanelHeader>
                        <div 
                            style={{
                                marginLeft: 20,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <CountdownCircleTimer
                                size={50}
                                strokeWidth={4}
                                isPlaying
                                duration={60 * 5}
                                colors={[["#FFC400", 0.33], ["#FF9100", 0.33], ["#FF3D00"]]}
                                onComplete={() => [true, 1000]}
                            >
                                {renderTime}
                            </CountdownCircleTimer>
                            <div
                                style={{marginLeft: 10}}
                            >
                                {t('refresh_countdown')}
                            </div>
                        </div>
                        <MenuItem style={{marginTop: 10}}>
                            <Checkbox checked={allChecked} onClick={toggleAllCheckboxValues}></Checkbox>
                            <span>{t('select_all')}</span>
                        </MenuItem>
                    </HideablePanelHeader>
                    }
                >
                <div style={{ overflow: "auto", height: '90%', width: '100vw' }}>
                    <LocalDeliveryManagement 
                        orders={orders} 
                        isChecked={isChecked}
                        clearAllChecked={clearAllChecked}
                        loading={loading}
                        handleCheckedOrders={handleCheckedOrders}
                    />
                </div>
            </HideablePanel>
            <HideablePanel
                id='rightPanel'
                containerStyle={classes.rightPanel} 
                position='right'
                tabs={workTabs}
                disabled={!_.isEmpty(rightPanelDisable)}
                disableMessage={rightPanelDisable.message}
                isContentLoading={mapManagement.staffLoading}
                headerComponent={
                    <HideablePanelHeader>
                        <DriverSearch 
                            onKeywordChange={delaySearch}
                        />
                    </HideablePanelHeader>
                }
            >
                {mapManagement.staffError ? <ListError />: workTabs.map((tab, index) => {
                    return (
                        <AccountList
                            handleDriverTransfer={handleDriverTransfer}
                            checkedOrders={checkedOrders}
                            usageFor='local_delivery'
                            key={`accountList-${index}`}
                            sectionLoading={mapManagement.ordersLoading}
                            orderList={mapManagement.ordersByDriver}
                            filter={orderFilters}
                            data={getAccountFilteredDistricts(_.filter(mapManagement.staff, function(staff){
                                if(tab.value === 0 || tab.value === 1){
                                    if(staff.workingarea === tab.label)
                                        return staff.id.toString().match(new RegExp(accountSearchKeyword, 'i'))
                                } else if(tab.value === 2){
                                    if((staff.workingarea !== "A" && staff.workingarea !== "B") && staff.workingstatus === 1)
                                        return staff.id.toString().match(new RegExp(accountSearchKeyword, 'i'))
                                } else if(tab.value === 3){
                                    if((staff.workingarea !== "A" && staff.workingarea !== "B") && staff.workingstatus === 0)
                                    return staff.id.toString().match(new RegExp(accountSearchKeyword, 'i'))
                                }
                            }))}
                        />
                    )
                })}
            </HideablePanel>
            <MapView
                center={getMapCenterByCityId(userPref.userCity)}
                id="mapView"
            >
            </MapView>
            <FullscreenLoading open={loadingFullscreen}/>
        </div>
    )

    function handleDriverTransfer(driverId) {
        setLoadingFullscreen(true);
        let paramsAssign = {
            orders: checkedOrders,
            to_driver: driverId,
            from_driver: null,
            operator: userPref.username
        } 
        dispatch(assignOrderToDriver(paramsAssign))
        .then(() => {
            setLoadingFullscreen(false);
            dispatch(showAlertSnackbar({message: t('transfer_success_message'), type: 'success'}))
        })
        .catch(() => {
            setLoadingFullscreen(false);
            dispatch(showAlertSnackbar({message: t('transfer_fail_message'), type: 'error'}))
        })
    }

    function handleCheckedOrders(checkedOrdersCurr) {
        setCheckedOrders(checkedOrdersCurr);
    }

    function clearAllChecked() {
        setAllChecked(false);
    }

    function toggleAllCheckboxValues() {
        setAllChecked(!allChecked);
        setIsChecked(isChecked.map(() => (!allChecked)));
    }

    function rightPanelLock(){
        let result = {}
        if(routeManagement.routePreview.routes.length > 0){
            result = {
                message: t('hint_lock_route_message')
            }
        }
        return result
    }
}

export default LocalDelivery